import { formatCurrency } from "@angular/common";
import { inject, Pipe, PipeTransform } from "@angular/core";
import { isString, isUndefined } from "lodash";
import { RegionService } from "src/app/services/feature-access-control/region.service";
import { LocaleService } from "src/app/services/locale.service";

@Pipe({
  name: "money",
  standalone: false
})
export class MoneyPipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);
  private readonly regionService = inject(RegionService);

  transform(value: string | number | undefined): string | null {
    if (!value && isUndefined(value)) {
      return null;
    }

    if (isString(value)) {
      value = parseFloat(value);
    }

    const currency = this.regionService.getCurrency();
    const currencySymbol = this.regionService.getCurrencySymbol();
    const locale = this.localeService.getCurrent();

    return formatCurrency(
      value,
      locale,
      currencySymbol + " ",
      currency,
      "1.2-2"
    ).trim();
  }
}
